import React, { FC } from 'react';
import { IconComponent } from './Icon.styles';
import iconSet from './selection.json';
import { Props } from '@sleepunique/types/icon-types';

const Icon: FC<Props> = ({
  icon,
  size = 'md',
  className = '',
  rotate = 0,
  color,

  ...props
}: Props) => (
  <IconComponent
    {...props}
    size={size}
    rotate={rotate}
    icon={icon}
    iconSet={iconSet}
    className={className}
    data-testid={`${icon}-${size}-icon`}
    color={color}
  />
);

export default Icon;
